export default function () {
  window.onbeforeunload = null;
}
